import React from "react";
import Skeleton, { SkeletonProps } from "./Skeleton";

export type BlockSkeletonProps = SkeletonProps;

export default function BlockSkeleton(
  props: BlockSkeletonProps
): JSX.Element {
  return <Skeleton borderRadius={12} {...props} />;
}
